import {defineMessages} from 'react-intl';

export const SellReadyMessage = defineMessages({
  'title': {
    id: "ReadyToSell.title",
    defaultMessage: "Ready to list?"
  },
  'buttonlabel': {
    id: "ReadyToSell.button.label",
    defaultMessage: "Sell my tickets"
  }
});
